<template>
    <geo></geo>
  </template>
  <script>
  import geo from "@/components/geolocation/geolocationConfig";
  
  export default {
    components: {
        geo
    }
  };
  </script>
  